import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, apiError } from "@/lib/api";
import { Panel, Btn, Field, Input } from "@/admin/ui";

const FIELDS = [
  ["entity", "Entity name"], ["email_general", "General email"], ["email_trade", "Trade email"],
  ["location", "Location"], ["trade_licence", "Trade Licence"], ["registration", "Registration"],
];

export default function ContactInfo() {
  const [form, setForm] = useState({});
  useEffect(() => { api.get("/api/admin/contact-info").then((r) => setForm(r.data || {})); }, []);
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));
  const save = async () => {
    try { await api.put("/api/admin/contact-info", form); toast.success("Contact info saved"); }
    catch (e) { toast.error(apiError(e)); }
  };
  return (
    <div data-testid="admin-contact">
      <h1 className="mb-6 text-2xl font-bold text-ink-heading">Contact & Corporate Info</h1>
      <Panel>
        <div className="grid gap-4 sm:grid-cols-2">
          {FIELDS.map(([k, label]) => (
            <Field key={k} label={label}><Input value={form[k] || ""} onChange={set(k)} data-testid={`contact-${k}`} /></Field>
          ))}
        </div>
        <div className="mt-6"><Btn onClick={save} data-testid="contact-save">Save</Btn></div>
      </Panel>
    </div>
  );
}
